import Vue from 'vue';

/**
 * RARC
 */
Vue.component('quality-management-tabs', require('./components/quality-management/Tabs').default);
// ESTADO 611
Vue.component('preparation-certificate-table', require('./components/quality-management/611/Index').default);
Vue.component('preparation-certificate-tabs', require('./components/quality-management/611/Tabs').default);
Vue.component('preparation-certificate-annexes', require('./components/quality-management/611/annexes/Index').default);
Vue.component('preparation-certificate-data', require('./components/quality-management/611/annexes/Data').default);
Vue.component('preparation-certificate-annexes-modal', require('./components/quality-management/611/annexes/Modal').default);

// Generación de certificados
Vue.component('generate-certificate-table', require('./components/quality-management/611/IndexCertificate').default);

//Documento de quejas
Vue.component('complaint-document-table', require('./components/complaintDocument/Index').default);
Vue.component('complaint-document-tabs', require('./components/complaintDocument/Tabs').default);
Vue.component('complaint-document-reason', require('./components/complaintDocument/reasons/Index').default);

//Revision de documento de quejas 
Vue.component('review-complaint-document-table', require('./components/reviewComplaintDocument/Index').default);
Vue.component('review-complaint-document-tabs', require('./components/reviewComplaintDocument/Tabs').default);
Vue.component('review-complaint-document-annexed', require('./components/reviewComplaintDocument/704/Annexed').default);
Vue.component('review-complaint-document-complaint', require('./components/reviewComplaintDocument/704/Complaint').default);

//Actualizacion de Informacion
Vue.component('update-information-tabs', require('./components/updateInformation/Tabs').default);
Vue.component('update-information-table', require('./components/updateInformation/614/Index').default);
Vue.component('update-information-modal', require('./components/updateInformation/614/Modal').default);

//Comision de quejas 
Vue.component('commission-complaint-document-table', require('./components/commissionComplaintDocument/Index').default);
Vue.component('commission-complaint-document-asig', require('./components/commissionComplaintDocument/Assignment').default);
Vue.component('commission-complaint-document-meeting', require('./components/commissionComplaintDocument/Meeting').default);
Vue.component('commission-complaint-document-tabs', require('./components/commissionComplaintDocument/707/Tabs').default);
Vue.component('commission-complaint-document-annexed', require('./components/commissionComplaintDocument/707/Annexed').default);
Vue.component('commission-complaint-document-select', require('./components/commissionComplaintDocument/707/CommissionMembers').default);
Vue.component('commission-complaint-document-meet-tabs', require('./components/commissionComplaintDocument/708/Tabs').default);
Vue.component('commission-complaint-document-meet-file', require('./components/commissionComplaintDocument/708/Complaint').default);
Vue.component('commission-complaint-document-meet-members', require('./components/commissionComplaintDocument/708/MembersComplaint').default);
